import { render, staticRenderFns } from "./UserPositionContainer.vue?vue&type=template&id=3585a0dc&scoped=true&"
import script from "./UserPositionContainer.vue?vue&type=script&lang=js&"
export * from "./UserPositionContainer.vue?vue&type=script&lang=js&"
import style0 from "./UserPositionContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserPositionContainer.vue?vue&type=style&index=1&id=3585a0dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3585a0dc",
  null
  
)

export default component.exports